<div class="filters-drawer-content">
    <div class="d-flex justify-content-between w-100 filters-header">
        <div class="left">
            <div class="filters-drawer-title">
                {{ 'DASHBOARD.FILTERS' | translate }}
            </div>
        </div>
        <div class="right font-weight-light clickable" [matTooltip]="'SHARED.CLOSE-ALT' | translate" matTooltipPosition="above" matTooltipHideDelay="200" (click)="closeFilterDrawer()">
            <span class="ti-close"></span>
        </div>
    </div>

    <div class="filters-drawer-values">
        <div class="filter-value">
            <div class="filter-title">
                {{ 'DASHBOARD.FILTER_BY' | translate }}:
            </div>
            <div class="radio-button-container">
                <div class="radio-button clickable" (click)="selectDateFilter(DashboardOrderDateType.ORDER_DATE)">
                    <span class="red-icon" [ngClass]="{ 'ti-control-stop': selectedDateFilter != DashboardOrderDateType.ORDER_DATE, 'ti-check-box': selectedDateFilter == DashboardOrderDateType.ORDER_DATE }"></span>
                    {{ 'DASHBOARD.DATE_TYPE.ORDER_DATE' | translate }}
                </div>
                <div class="radio-button clickable" (click)="selectDateFilter(DashboardOrderDateType.DELIVERY_DATE)">
                    <span class="red-icon" [ngClass]="{ 'ti-control-stop': selectedDateFilter != DashboardOrderDateType.DELIVERY_DATE, 'ti-check-box': selectedDateFilter == DashboardOrderDateType.DELIVERY_DATE  }"></span>
                    {{ 'DASHBOARD.DATE_TYPE.DELIVERY_DATE' | translate }}
                </div>
            </div>
        </div>
        <div class="filter-value" *ngIf="showCustomerType">
            <div class="filter-title">
                {{ 'DASHBOARD.FILTER_BY' | translate }}:
            </div>
            <div class="radio-button-container">
                <div class="radio-button clickable" (click)="selectCustomerFilter(null)">
                    <span class="red-icon" [ngClass]="{ 'ti-control-stop': selectedCustomerFilter != null, 'ti-check-box': selectedCustomerFilter == null }"></span>
                    {{ 'USERS.ALL' | translate }}
                </div>
                <div class="radio-button clickable" (click)="selectCustomerFilter(DashboardCustomerType.REGISTERED)">
                    <span class="red-icon" [ngClass]="{ 'ti-control-stop': selectedCustomerFilter != DashboardCustomerType.REGISTERED, 'ti-check-box': selectedCustomerFilter == DashboardCustomerType.REGISTERED  }"></span>
                    {{ 'USERS.REGISTERED' | translate }}
                </div>
                <div class="radio-button clickable" (click)="selectCustomerFilter(DashboardCustomerType.PUBLIC)">
                    <span class="red-icon" [ngClass]="{ 'ti-control-stop': selectedCustomerFilter != DashboardCustomerType.PUBLIC, 'ti-check-box': selectedCustomerFilter == DashboardCustomerType.PUBLIC  }"></span>
                    {{ 'USERS.PUBLIC' | translate }}
                </div>
            </div>
        </div>
        <div class="filter-value">
            <div class="filter-title">
                {{ 'DASHBOARD.TIME_PERIOD' | translate }}:
            </div>
            <div class="filter-label">
                {{ 'SHARED.PERIOD_FROM' | translate }}
            </div>
            <dx-date-box
                [(value)]="periodFrom"
                type="date"
                (ckic)="utilityService.openCalendar"
                displayFormat="dd.MM.yyyy"
                [showClearButton]="false">
            </dx-date-box>
            <div class="filter-label">
                {{ 'SHARED.PERIOD_TO' | translate }}
            </div>
            <dx-date-box
                [(value)]="periodTo"
                type="date"
                (ckic)="utilityService.openCalendar"
                displayFormat="dd.MM.yyyy"
                [showClearButton]="false">
            </dx-date-box>
        </div>
        <div class="filter-value" *ngIf="showMunicipalities">
            <div class="filter-title">
                {{ 'MENU.DATA_MANAGEMENT.MUNICIPALITIES' | translate }}:
            </div>
            <app-tag-box 
                    [url]="municipalitiesUrl"
                    [selectedData]="selectedMunicipalities" 
                    [dataSource]="municipalities" 
                    [valueExpr]="'id'" 
                    [displayExpr]="'name'" 
                    [readOnly]="false"
                    (onSelectionChangedEvent)="onMunicipalitiesSelectionChanged($event)"
                >
            </app-tag-box>
        </div>
        <div class="filter-value" *ngIf="showCategories">
            <div class="filter-title">
                {{ 'DASHBAORD.CATEGORIES' | translate }}:
            </div>
            <app-tag-box 
                    [url]="productMerchandiseGroupsUrl"
                    [selectedData]="selectedCategories" 
                    [dataSource]="productMerchandiseGroups" 
                    [valueExpr]="'id'" 
                    [displayExpr]="'name'" 
                    [readOnly]="false"
                    (onSelectionChangedEvent)="onProductMerchandiseGroupChanged($event)"
                >
            </app-tag-box>
        </div>
        <div class="filter-value" *ngIf="showPointsOfSale">
            <div class="filter-title">
                {{ 'MENU.ADMINISTRATION.POINTS_OF_SALE' | translate }}:
            </div>
            <app-tag-box 
                    [url]="pointsOfSaleUrl"
                    [selectedData]="selectedPointsOfSale" 
                    [dataSource]="pointsOfSale" 
                    [valueExpr]="'id'" 
                    [displayExpr]="'name'"
                    [readOnly]="false"
                    (onSelectionChangedEvent)="onPointsOfSaleChanged($event)"
                >
            </app-tag-box>
        </div>
        <div class="filter-value" *ngIf="showDeliveryLocations">
            <div class="filter-title">
                {{ 'BUSINESS_PARTNER.DELIVERY_LOCATIONS' | translate }}:
            </div>
            <app-tag-box 
                    [url]="deliveryLocationsUrl"
                    [selectedData]="selectedDeliveryLocations" 
                    [dataSource]="deliveryLocations" 
                    [valueExpr]="'id'" 
                    [displayExpr]="'name'" 
                    [readOnly]="false"
                    (onSelectionChangedEvent)="onDeliveryLocationsChanged($event)"
                >
            </app-tag-box>
        </div>
    </div>
    <div class="filter-drawer-buttons">
        <button mat-button class="btn-green-70 outline-none" (click)="applyFilters()">
            {{ 'DASHBOARD.APPLY_FILTERS' | translate}}
        </button>
        <button mat-button class="outline-none" (click)="clearFilters()">
            {{ 'DASHBOARD.CLEAR_FILTERS' | translate}}
        </button>
    </div>
</div>